import get from 'lodash/get';

export const getMenu = (state) => get(state, 'secured.menu', {});



// WEBPACK FOOTER //
// src/modules/secured/selectors/secured_selectors.js